import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ActionsIcon from 'assets/icons/more-circle.svg';
import { useTranslation } from 'utils/modifiedTranslation';
import { useOnClickOutside } from 'utils/hooks/useOnClickOutside';

export const MatchesListHeaderView = ({
  actions = [], toggleMenu, isMenuShown, isTreatmentTypeFilterDisabled, closeMenu,
}) => {
  const { t } = useTranslation();
  const menuRef = useRef(null);
  useOnClickOutside(menuRef, closeMenu);
  return (
    <div className={cx('result-list-header', { 'treatment-type-filter-enabled': !isTreatmentTypeFilterDisabled })}>
      <div className="result-list-header-main">
        <span>{t('treatment_options.title')}</span>
      </div>
      {!!actions.length && (
        <div className="result-list-header-actions">
          <div
            className="result-list-mobile-header-actions-menu"
            onClick={toggleMenu}
          >
            <img alt="" src={ActionsIcon} />
            <div
              ref={menuRef}
              className={cx('result-list-mobile-actions', { 'mobile-actions-show': isMenuShown })}
            >
              <div className="results-header">
                {actions}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

MatchesListHeaderView.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.node),
  toggleMenu: PropTypes.func,
  closeMenu: PropTypes.func,
  isMenuShown: PropTypes.bool,
  isTreatmentTypeFilterDisabled: PropTypes.bool,
};
